import request from '@/utils/request'


// 查询中奖记录列表
export function listLotteryRecord(query) {
  return request({
    url: '/biz/admin/lottery/lottery/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询中奖记录分页
export function pageLotteryRecord(query) {
  return request({
    url: '/biz/admin/lottery/lottery/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询中奖记录详细
export function getLotteryRecord(data) {
  return request({
    url: '/biz/admin/lottery/lottery/record/detail',
    method: 'get',
    params: data
  })
}

// 新增中奖记录
export function addLotteryRecord(data) {
  return request({
    url: '/biz/admin/lottery/lottery/record/add',
    method: 'post',
    data: data
  })
}

// 修改中奖记录
export function updateLotteryRecord(data) {
  return request({
    url: '/biz/admin/lottery/lottery/record/edit',
    method: 'post',
    data: data
  })
}

// 删除中奖记录
export function delLotteryRecord(data) {
  return request({
    url: '/biz/admin/lottery/lottery/record/delete',
    method: 'post',
    data: data
  })
}
